import React, { useEffect, useContext, useState } from "react";
import { styles } from "./patients/dashboardstyle";

import api, { API_URL, showAlert, AuthContext, toNaira } from "./util/api";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "./header";
import Footer from "./footer";
import "./paginationstyle.css";
import PremiumLoader from "./loading";
import NoData from "./components/nodata";

export default function WithdrawHistory() {

    const { User, token, Doctor, Patient } = useContext(AuthContext);
    const [loading, setLoader] = useState(true);
    const [balance, setbalance] = useState(0);
    const [Withdrawn, setwithdrawn] = useState(0);
    const [dashboardLink, setDashoardLink] = useState("");

    const router = useNavigate();

    const [transactions, setTransactions] = useState([]);

    const [hovered, setHovered] = React.useState(null);

    // 🔹 Withdraw States
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [withdrawType, setWithdrawType] = useState("bank");
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawLoading, setWithdrawLoading] = useState(false);
    const [completedWithdrawals, setCompletedWithdrawals] = useState(0);
    const [pendingWithdrawals, setPendingWithdrawals] = useState(0);
    const [processingWithdrawals, setProcessingWithdrawals] = useState(0);

    const fadeIn = { animation: "fadeIn 0.8s ease-out" };
    const slideUp = { animation: "slideUp 0.8s ease-out" };

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
    });

    // FETCH DATA
    const getdata = async (page = 1) => {
        setLoader(true);
        const response = await api.get(`${API_URL}/transactions?page=${page}`);

        if (response.data.status === "success") {
            let info = response.data;

            setTransactions(info.withdraw_history.data);
            setCompletedWithdrawals(info.completed_withdrawals);
            setPendingWithdrawals(info.pending_withdrawals);
            setProcessingWithdrawals(info.processing_withdrawals);
            setwithdrawn(info.withdrawn);
            setbalance(info.balance);

            setPagination({
                current_page: info.withdraw_history.current_page,
                last_page: info.withdraw_history.last_page,
                next_page_url: info.withdraw_history.next_page_url,
                prev_page_url: info.withdraw_history.prev_page_url,
            });

            setLoader(false);
        } else {
            showAlert("error", "Error!", response.data.message);
            setLoader(false);
        }
    };

    // 🔹 Withdraw Submit
    const handleWithdraw = async () => {

        if (!withdrawAmount || withdrawAmount <= 0) {
            return showAlert("error", "Invalid Amount", "Enter a valid withdrawal amount.");
        }


        /*    if (withdrawAmount > balance) {
               return showAlert("error", "Insufficient Balance", "Withdrawal exceeds wallet balance.");
           } */

        try {
            setWithdrawLoading(true);

            const response = await api.post(`${API_URL}/withdraw`, {
                amount: withdrawAmount,
                type: withdrawType
            });

            if (response.data.status === "success") {
                showAlert("success", "Success", response.data.message);
                setShowWithdrawModal(false);
                setWithdrawAmount("");
                getdata();
            } else {
                setShowWithdrawModal(false);
                setWithdrawAmount("");
                showAlert("error", "Error", response.data.message);
            }

        } catch (err) {

            setShowWithdrawModal(false);
            setWithdrawAmount("");
            showAlert("error", "Error", "Something went wrong.");
        }

        setWithdrawLoading(false);
    };

    useEffect(() => {
        if (User == null || token == null) {
            router("/login");
        } else {
            if (Doctor != null) setDashoardLink("/lawyer-dashboard");
            if (Patient != null) setDashoardLink("/client-dashboard");
        }

        getdata();
    }, []);

    return (
        <>
            <Navbar menuColor="red" />

            <section>
                <div style={styles.container}>

                    {/* TOP CARD */}
                    <div style={{ ...styles.card, ...fadeIn }}>

                        <div style={styles.header}>
                            <Link to={dashboardLink}>
                                <button
                                    onClick={() => router(-1)}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        fontSize: 16,
                                        padding: 0,
                                    }}
                                >
                                    ← Back
                                </button>
                            </Link>
                        </div>

                        <br />

                        <div style={styles.grid}>
                            {[
                                { label: "Completed Withdrawals", value: toNaira(completedWithdrawals) },
                                { label: "Pending Withdrawals", value: toNaira(pendingWithdrawals) },
                                { label: "Processing Withdrawals", value: toNaira(processingWithdrawals) },

                            ].map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        ...styles.statBox,
                                        ...(hovered === index && styles.statBoxHover),
                                        ...slideUp,
                                    }}
                                    onMouseEnter={() => setHovered(index)}
                                    onMouseLeave={() => setHovered(null)}
                                >
                                    <div style={styles.statLabel}>{item.label}</div>
                                    <div style={styles.statValue}>{item.value}</div>
                                </div>
                            ))}
                        </div>

                        {/* 🔥 Withdraw Button */}
                        <div style={{ marginTop: 25, textAlign: "center" }}>
                            <button
                                onClick={() => setShowWithdrawModal(true)}
                                style={{
                                    padding: "12px 30px",
                                    background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
                                    border: "none",
                                    borderRadius: 50,
                                    color: "#fff",
                                    fontSize: 16,
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    boxShadow: "0 8px 20px rgba(255,75,43,0.4)",
                                    transition: "0.3s ease"
                                }}
                            >
                                Withdraw Funds
                            </button>
                        </div>
                    </div>

                    {/* TABLE CARD (UNCHANGED FUNCTIONALITY) */}
                    <div style={{ ...styles.card, ...fadeIn }}>
                        <div style={styles.header}>Transactions</div>
                        <br />

                        {loading ? (
                            <PremiumLoader />
                        ) : transactions.length === 0 ? (
                            <NoData />
                        ) : (
                            <>
                                <div style={styles.tableContainer}>
                                    <table style={styles.table}>
                                        <thead>
                                            <tr>
                                                <th style={styles.th}>Amount</th>
                                                <th style={styles.th}>Type</th>
                                                <th style={styles.th}>Status</th>
                                                <th style={styles.th}>Description</th>
                                                <th style={styles.th}>Method</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions.map((row, index) => (
                                                <tr key={index}>
                                                    <td style={styles.td}>{toNaira(row.amount)}</td>
                                                    <td style={styles.td}>{row.type || " "}</td>
                                                    <td style={styles.td}>{row.status || " "}</td>
                                                    <td style={styles.td}>{row.description}</td>
                                                    <td style={styles.td}>{row.method || " "}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </section>

            {/* 🔥 BEAUTIFUL MODAL */}
            {showWithdrawModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999
                }}>
                    <div style={{
                        width: "95%",
                        maxWidth: 450,
                        background: "#fff",
                        borderRadius: 20,
                        padding: 30,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.2)"
                    }}>
                        <h3 style={{ marginBottom: 20, textAlign: "center" }}>Withdraw Funds</h3>

                        <div style={{ marginBottom: 15 }}>
                            <label>Select Withdrawal Method</label>
                            <select
                                value={withdrawType}
                                onChange={(e) => setWithdrawType(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: 10,
                                    borderRadius: 8,
                                    marginTop: 5
                                }}
                            >
                                <option value="bank">Bank Deposit</option>
                                <option value="crypto">Crypto Deposit</option>
                            </select>
                        </div>

                        <div style={{ marginBottom: 20 }}>
                            <label>Amount</label>
                            <input
                                type="number"
                                placeholder="Enter amount"
                                value={withdrawAmount}
                                onChange={(e) => setWithdrawAmount(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: 10,
                                    borderRadius: 8,
                                    marginTop: 5
                                }}
                            />
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => setShowWithdrawModal(false)}
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: 8,
                                    border: "none",
                                    background: "#ccc",
                                    cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={handleWithdraw}
                                disabled={withdrawLoading}
                                style={{
                                    padding: "10px 25px",
                                    borderRadius: 8,
                                    border: "none",
                                    background: "#28a745",
                                    color: "#fff",
                                    fontWeight: 600,
                                    cursor: "pointer"
                                }}
                            >
                                {withdrawLoading ? "Processing..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}